import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Avatar, Container, Divider, Drawer, ListItem, ListItemAvatar, ListItemButton, ListItemText, SpeedDial, SpeedDialAction, SpeedDialIcon, Tab, Tabs, Toolbar, Typography } from '@mui/material';
import { getLightPoints, getLightPoint, getCabinets, getLamps, userCanEdit, getDevices } from '../helpers/helper';
import { MAP } from "react-google-maps/lib/constants"
import GPSIcon from '@mui/icons-material/GpsFixed';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import RouterIcon from '@mui/icons-material/Router';
import AddLightPointForm from './AddLightPointForm';
import AddCabinetForm from './AddCabinetForm';
import { UploadFile } from '@mui/icons-material';
import TopAppBar from './TopAppBar';
import Map from './Map';
import { Box } from '@mui/material';
import CSVUploadForm from './CSVUploadForm';
import UserProfileForm from './UserProfileForm';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert'

class MainLayout extends Component {
    constructor(props) {
        super(props);
        // Verifica se presente un progetto selezionato
        // Se è presente -> inizializza lo stato del centro mappa con le coordinate del progetto
        // In caso contrario, prende il primo progetto della lista
        this.state = {
            projectIdSelected: null,
            mapCenter: {
                lat: null,
                lng: null,
                zoom: null
            },
            drawerOpen: false,
            drawerTab: 0,
            dialogOpen: null,
            lightPoints: [],
            cabinets: [],
            gateways: [],
            lampsArchive: [],
            luminaresArchive: [],
            driversArchive: [],
            supportsArchive: [],
            showNoLightPointsToast: false,
            showNoCabinetToast: false,
            showNoLampToast: false,
            isMapReady: false
        }

        this.mapComponent = null;

        // Bind
        this.handleMapReady = this.handleMapReady.bind(this);
        this.checkForInit = this.checkForInit.bind(this);
        this.setMainLayoutState = this.setMainLayoutState.bind(this);
        this.onChangeProject = this.onChangeProject.bind(this);
        this.handleMapMounted = this.handleMapMounted.bind(this);

        this.handleClickOpenLightPoint = this.handleClickOpenLightPoint.bind(this);
        this.handleDialogLightPoint = this.handleDialogLightPoint.bind(this);
        this.handleAddLightPoint = this.handleAddLightPoint.bind(this);
        this.handlePutLightpoint = this.handlePutLightpoint.bind(this);
        this.handleDelLightpoint = this.handleDelLightpoint.bind(this);

        this.handleClickOpenCabinet = this.handleClickOpenCabinet.bind(this);
        this.handleDialogCabinet = this.handleDialogCabinet.bind(this);
        this.handleAddCabinet = this.handleAddCabinet.bind(this);
        this.handlePutCabinet = this.handlePutCabinet.bind(this);
        this.handleDelCabinet = this.handleDelCabinet.bind(this);

        this.handleGetGpsCoord = this.handleGetGpsCoord.bind(this);

        this.handleClickOpenUpload = this.handleClickOpenUpload.bind(this);
        this.handleDialogUpload = this.handleDialogUpload.bind(this);
        this.handleCSVUploadSuccess = this.handleCSVUploadSuccess.bind(this);


        this.handleClickOpenProfile = this.handleClickOpenProfile.bind(this);
        this.handleDialogProfile = this.handleDialogProfile.bind(this);
    }

    componentDidMount() {
        this.checkForInit();
    }

    /**
     *
     * @param {*} map
     */
    handleMapMounted(map) {
        if (map) {
            if (map && map.context[MAP]) {
                this.map = map.context[MAP];
                /*if (!google.maps.event.hasListeners(this.map.data, 'click')) {
                    this.map.data.addListener("click", this.handleMarkerClick.bind(this));
                    this.map.data.addListener('setgeometry', this.handleSetGeometry.bind(this));
                }
                this.renderMapFeatures();*/
            }
        }
    }

    handleMapReady(mapComponent) {
        this.mapComponent = mapComponent;
        this.setState({ isMapReady: true });
    }

    /**
     * Gestore delle coordinate e posizione rilevata dal gps
     */
    handleGetGpsCoord() {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    this.map.setCenter({ lat: position.coords.latitude, lng: position.coords.longitude });
                    // Sposto la mappa in base alle coordinate
                    //this.setState({ 'mapCenter': { 'lat': position.coords.latitude, 'lng': position.coords.longitude } });
                },
                function (error) {
                    console.error("error", "Map.js", "handleMyPosition", "Error Code = " + error.code + " - " + error.message);
                }
            );

        } else {
            console.warn("warning", "Map.js", "handleMyPosition", "GEOLACATION_ERROR");
        }
    }

    /**
     * Gestore per l'aggiunta di un nuovo punto luce
     * @param {*} newLightPoint
     */
    handleAddLightPoint(newLightPoint) {
        // Soluzione con ricarico parziale
        getLightPoint(newLightPoint.uuid)
            .then((res) => {
                let { lightPoints } = this.state;
                lightPoints.push(res.data.rows[0]);
                this.setState({ 'lightPoints': lightPoints, 'mapCenter': this.tmpMapCenter }, () => {
                    if (this.state.isMapReady) {
                        this.mapComponent.getAndSetBounds();
                    }
                });
            })
            .catch((err) => {
                console.error("error", "MainLayout.jsx", "setMainLayoutStatus", err);
            });
    }

    /**
     * Gestore per l'aggiunta di un nuovo cabinato
     * @param {*} newLightPoint
     */
    handlePutLightpoint(putLightpoint) {
        // Soluzione con ricarico parziale
        getLightPoint(putLightpoint[0].uuid)
            .then((res) => {
                let { lightPoints } = this.state;
                for (let i = 0; i < lightPoints.length; i++) {
                    if (lightPoints[i].uuid === putLightpoint[0].uuid) {
                        lightPoints[i] = {
                            ...lightPoints[i],
                            ...res.data.rows[0]
                        };
                        break;
                    }
                }
                this.setState({ 'lightPoints': lightPoints, 'mapCenter': this.tmpMapCenter }, () => {
                    if (this.state.isMapReady) {
                        this.mapComponent.getAndSetBounds();
                    }
                });
            })
            .catch((err) => {
                console.error("error", "MainLayout.jsx", "setMainLayoutStatus", err);
            });
    }

    /**
     * Gestore per l'aggiunta di un nuovo cabinato
     * @param {*} newLightPoint
     */
    handleDelLightpoint(delLightpoint) {
        let { lightPoints } = this.state;
        lightPoints = lightPoints.filter((x) => x.uuid !== delLightpoint.uuid);
        this.setState({ 'lightPoints': lightPoints, 'mapCenter': this.tmpMapCenter }, () => {
            if (this.state.isMapReady) {
                this.mapComponent.getAndSetBounds();
            }
        });
    }

    /**
     * Gestore per l'aggiunta di un nuovo cabinato
     * @param {*} newLightPoint
     */
    handleAddCabinet(newCabinet) {
        let { cabinets } = this.state;
        cabinets.push(newCabinet);
        this.setState({ 'cabinets': cabinets, 'mapCenter': this.tmpMapCenter }, () => {
            if (this.state.isMapReady) {
                /*Ho impostato questa logica perche al'avvio dell software dopo di aver creato un CABINET,
                e in seguito andando a creare un LP non era valutato il gateway nel select*/
                if(cabinets !== null || cabinets !== ""){
                    this.mapComponent.getAndSetBounds();
                    this.checkForInit() //In questa maniera ricarica tutto il setMainLayout() e receupera il valore dei gateways
                } else {
                    this.mapComponent.getAndSetBounds();
                }
            }
        });
    }

    /**
     * Gestore per l'aggiunta di un nuovo cabinato
     * @param {*} newLightPoint
     */
    handlePutCabinet(putCabinet) {
        let { cabinets } = this.state;
        for (let i = 0; i < cabinets.length; i++) {
            if (cabinets[i].uuid === putCabinet.uuid) {
                cabinets[i] = {
                    ...cabinets[i],
                    ...putCabinet
                };
                break;
            }
        }
        this.setState({ 'cabinets': cabinets, 'mapCenter': this.tmpMapCenter }, () => {
            if (this.state.isMapReady) {
                this.mapComponent.getAndSetBounds();
            }
        });
    }

    /**
     * Gestore per l'aggiunta di un nuovo cabinato
     * @param {*} newLightPoint
     */
    handleDelCabinet(delCabinet) {
        let { cabinets } = this.state;
        cabinets = cabinets.filter((x) => x.uuid !== delCabinet.uuid);
        this.setState({ 'cabinets': cabinets, 'mapCenter': this.tmpMapCenter }, () => {
            if (this.state.isMapReady) {
                this.mapComponent.getAndSetBounds();
            }
        });
    }

    /**
     * Recupero dal componente figlio la funzione di apertura dialog aggiunta punto luce
     * @param {*} dialog
     */
    handleDialogLightPoint(dialog) {
        if (dialog) {
            this.dialogLightPointOpen = dialog;
        }
    }

    /**
     * Recupero dal componente figlio la funzione di apertura dialog aggiunta cabinet
     * @param {*} dialog
     */
    handleDialogCabinet(dialog) {
        if (dialog) {
            this.dialogCabinetOpen = dialog;
        }
    }

    // Aggiorna lo state con i nuovi lightpoints
    async handleCSVUploadSuccess(data) {
        // Recupero dei lightpoints dopo di che abbiamo aggiunto nuovi LP con il UPLOAD
        // Questo e l'unico modo per settare tutte le proprieta dentro la list dei LP
        await getLightPoints(this.state.projectIdSelected) 
            .then((res) => {
                if (res.data.rows && res.data.rows.length > 0){

                    this.setState({ lightPoints: res.data.rows }, () => {
                        if (this.state.isMapReady) {
                            this.mapComponent.getAndSetBounds();
                        }
                    });

                } else {
                    //Se non ci sono lightpoints lo state sara vuoto
                    setTimeout(() => {
                        this.setState({ lightPoints: [], showNoLightPointsToast: true })
                    }, 6000)
                    setTimeout(() => {
                        this.setState({ showNoLightPointsToast: false})
                    }, 9000)
                }
            })
            .catch((err) => {
                console.error(err);
                this.setState({ lightPoints: [] });
            });
    }

    /**
     * Recupero dal componente figlio la funzione di apertura dialog upload
     * @param {*} dialog
     */
    handleDialogUpload(dialog) {
        if (dialog) {
            this.dialogUploadOpen = dialog;
        }
    }

    /**
     * Recupero dal componente figlio la funzione di apertura dialog profilo
     * @param {*} dialog
     */
    handleDialogProfile(dialog) {
        if (dialog) {
            this.dialogProfileOpen = dialog;
        }
    }

    /**
     * Gestione del pulsante di aggiunta punto luce
     * Vengono salvate le coordinate del centro mappa e dello zoom
     * per poi essere reimpostate all'aggiornamento dello stato dopo l'aggiunta di un lightpoint
     */
    handleClickOpenLightPoint(lightpointId = null) {
        if (this.mapComponent && this.mapComponent.map) {
            const mapCenter = this.mapComponent.map.getCenter();
            const mapZoom = this.mapComponent.map.getZoom();
            this.dialogLightPointOpen({ lightpointId: lightpointId, lat: mapCenter.lat(), lng: mapCenter.lng() });
            this.tmpMapCenter = {
                lat: mapCenter.lat(),
                lng: mapCenter.lng(),
                zoom: mapZoom
            };
        }
    }

    /**
     * Gestione del pulsante di aggiunta cabinet
     * Vengono salvate le coordinate del centro mappa e dello zoom
     * per poi essere reimpostate all'aggiornamento dello stato dopo l'aggiunta di un lightpoint
     */
    handleClickOpenCabinet(cabinetId = null) {
        if (this.mapComponent && this.mapComponent.map) {
            const mapCenter = this.mapComponent.map.getCenter();
            const mapZoom = this.mapComponent.map.getZoom();
            this.dialogCabinetOpen({ cabinetId: cabinetId, lat: mapCenter.lat(), lng: mapCenter.lng() });
            this.tmpMapCenter = {
                lat: mapCenter.lat(),
                lng: mapCenter.lng(),
                zoom: mapZoom
            };
        }
    }

    handleClickOpenUpload(objects = null) {
        this.dialogUploadOpen(objects);
    }

    handleClickOpenProfile(objects = null) {
        this.dialogProfileOpen(objects);
    }

    /**
     * Funzione di inizializzazione dei parametri
     */
    checkForInit() {
        // verifica selezione del projectId
        if (this.props.app && (this.props.app.projectId === null || this.props.app.projectId === undefined)) {
            // Inizializza con il primo valore se esiste
            if (this.props.app.projects && this.props.app.projects.length > 0) {
                const firstProject = this.props.app.projects[0];
                localStorage.setItem("currentProjectId", firstProject.uuid);
                this.setMainLayoutState(firstProject);
            }
        } else {
            // Il progetto è già selezionato -> inizializza lo stato del centro mappa
            if (this.props.app.user && this.props.app.user !== null) {
                let project = this.props.app.projects.find((prj) => prj.uuid === this.props.app.projectId);
                this.setMainLayoutState(project);
            }
        }
    }

    /**
     * Funzione per gestire il cambio di progetto
     * @param {*} newProjectId
     */
    onChangeProject(newProjectId) {
        let project = this.props.app.projects.find((prj) => { return prj.uuid === newProjectId });
        this.setMainLayoutState(project);
        if(this.state.isMapReady){
            this.mapComponent.getAndSetBounds();
        }
    }

    /**
     * Funzione per l'aggiornamento dello stato del MainLayout
     * @param {*} project
     */
    setMainLayoutState(project) {
        if (project){
            this.setState({
                projectIdSelected: project.uuid,
                mapCenter: {
                    lng: project.geometry[0],
                    lat: project.geometry[1],
                    zoom: 14
                }
            });
        } else {
            console.error("Project not found or undefined ")
        }

        // Recupero dei lightpoints
        getLightPoints(project.uuid)
            .then((res) => {
                if (res.data.rows && res.data.rows.length > 0){
                    this.setState({ lightPoints: res.data.rows });
                } else {
                    //Se non ci sono lightpoints lo state sara vuoto
                    setTimeout(() => {
                        this.setState({ lightPoints: [], showNoLightPointsToast: true })
                    }, 6000)
                    setTimeout(() => {
                        this.setState({ showNoLightPointsToast: false})
                    }, 9000)
                }
            })
            .catch((err) => {
                console.error(err);
                this.setState({ lightPoints: [] });
            });

        // Recupero dei cabinet
        getCabinets(project.uuid)
            .then((res) => {
                if(res.data.rows && res.data.rows.length > 0){
                    this.setState({ cabinets: res.data.rows });
                } else {
                    //Se non ci sono cabinets lo state sara vuoto
                    this.setState({ cabinets: [], showNoCabinetToast: true })
                    setTimeout(() => {
                        this.setState({ showNoCabinetToast: false })
                    }, 4000)
                }
            })
            .catch((err) => {
                console.error(err);
                this.setState({ cabinets: [] });
            });

        //Recupero dei gateways
        const sn = null
        const isGateway = true
        const projectuuid = localStorage.getItem("currentProjectId");

        getDevices(sn, isGateway, projectuuid)
            .then((res) => {
                if(res.data.rows && res.data.rows.length > 0){
                    this.setState({ gateways: res.data.rows });
                } else {
                    //Se non ci sono gateways lo state sara vuoto
                    this.setState({ gateways: [] })
                }
            })
            .catch((err) => {
                console.error(err)
                this.setState({ gateways: [] })
            })

        // Recupero degli archivi componenti
        getLamps(projectuuid)
            .then((res) => {
                if(res.data.rows && res.data.rows.length > 0){
                    this.setState({ lampsArchive: res.data.rows });
                } else {
                    this.setState({ lampsArchive: [], showNoLampToast: true})
                    setTimeout(() => {
                        this.setState({ showNoLampToast: false })
                    }, 5000)
                }
            })
            .catch((err) => {
                console.error(err);
                this.setState({ lampsArchive: [] });
            });
        //getLuminares()                                    DEPRECATA. I dati della tabella luminares sono stati integrti in lamparchive
        //    .then((res) => {
        //        this.setState({ luminaresArchive: res.data });
        //    })
        //    .catch((err) => {
        //        console.error(err);
        //        this.setState({ luminaresArchive: [] });
        //    });
        //getDrivers()                                      DEPRECATA. I dati della tabella luminares sono stati integrti in lamparchive      
        //    .then((res) => {
        //        this.setState({ driversArchive: res.data });
        //    })
        //    .catch((err) => {
        //        console.error(err);
        //        this.setState({ driversArchive: [] });
        //    });
        //getSupports()                                     DEPRECATA. I dati della tabella luminares sono stati integrti in lamparchive
        //    .then((res) => {
        //        this.setState({ supportsArchive: res.data });
        //    })
        //    .catch((err) => {
        //        console.error(err);
        //        this.setState({ supportsArchive: [] });
        //    });
    }

    render() {
        const { t } = this.props;
        const canEdit = userCanEdit();
        const { showNoLightPointsToast } = this.state
        const { showNoCabinetToast } = this.state
        const { showNoLampToast } = this.state

        return (
            <Container maxWidth={false} disableGutters={true}>
                <Snackbar
                    open={showNoLightPointsToast}
                    autohideduration={3000}
                >
                    <MuiAlert
                        elevation={6}
                        variant="filled"
                        severity="warning"
                        autohideduration={3000}
                    >
                        Nessun dato di lightpoints disponibile.
                    </MuiAlert>
                </Snackbar>
                
                <Snackbar
                    open={showNoCabinetToast}
                    autohideduration={3000}
                >
                    <MuiAlert
                        elevation={6}
                        variant="filled"
                        severity="warning"
                        autohideduration={3000}
                    >
                        Nessun dato di cabinets disponibile.
                    </MuiAlert>
                </Snackbar>

                <Snackbar
                    open={showNoLampToast}
                    autohideduration={3000}
                >
                    <MuiAlert
                        elevation={6}
                        variant="filled"
                        severity="warning"
                        autohideduration={3000}
                    >
                        Nessun dato di Lampade disponibile.
                    </MuiAlert>
                </Snackbar>

                <TopAppBar
                    user={this.props.app.user}
                    projectId={this.props.app.projectId}
                    projects={this.props.app.projects}
                    onChangeProject={this.onChangeProject}
                    updateLoginState={this.props.updateLoginState}
                    onDrawerClick={() => this.setState({ drawerOpen: true })}
                    onProfileClick={() => this.handleClickOpenProfile()}
                />

                <Map
                    mapCenter={this.state.mapCenter}
                    onMapReady={this.handleMapReady}
                    //lightPoints={this.state.lightPoints}
                    //cabinets={this.state.cabinets}
                    handleMapMounted={this.handleMapMounted}
                    containerElement={<div style={{ height: "calc(var(--vh, 1vh) * 100)" }} />}
                    mapElement={<div style={{ minHeight: "100%" }} />}
                />

                <SpeedDial
                    ariaLabel="speed_dial_actions"
                    sx={{ position: 'absolute', bottom: 25, right: 25 }}
                    icon={<SpeedDialIcon />}>
                    {canEdit && <SpeedDialAction
                        key={"upload_csv_file"}
                        icon={<UploadFile />}
                        tooltipTitle={t("upload_csv_file")}
                        onClick={() => this.handleClickOpenUpload()}
                        sx={{
                            display: {
                                xs: 'none',
                                sm: 'none',
                                md: 'none',
                                lg: 'block',
                                xl: 'block'
                            }
                        }}
                    />}
                    {canEdit && <SpeedDialAction
                        key={"add_cabinet"}
                        icon={<RouterIcon />}
                        tooltipTitle={t("add_cabinet")}
                        onClick={() => this.handleClickOpenCabinet()}
                    />}
                    {canEdit && <SpeedDialAction
                        key={"add_light_point"}
                        icon={<EmojiObjectsIcon />}
                        tooltipTitle={t("add_lightpoint")}
                        onClick={() => this.handleClickOpenLightPoint()}
                    />}
                    <SpeedDialAction
                        key={"get_current_location"}
                        icon={<GPSIcon />}
                        tooltipTitle={t("get_current_location")}
                        onClick={this.handleGetGpsCoord}
                    />
                </SpeedDial>

                <Drawer
                    PaperProps={{
                        sx: {
                            width: {
                                xs: '80%',
                                sm: '360px',
                                md: '360px',
                                lg: '360px',
                                xl: '360px'
                            }
                        }
                    }}
                    open={this.state.drawerOpen}
                    onClose={() => this.setState({ drawerOpen: false })}>
                    <Toolbar>
                        <Typography variant="h5">{t("data_registry")}</Typography>
                    </Toolbar>
                    <Divider />
                    <Box sx={{ borderBottom: 1, borderColor: 'rgba(0, 0, 0, 0.12)' }}>
                        <Tabs centered
                            value={this.state.drawerTab}
                            onChange={(event, newValue) => this.setState({ drawerTab: newValue }) }>
                            <Tab label={t("cabinets")} />
                            <Tab label={t("lightpoints")} />
                        </Tabs>
                    </Box>
                    <div className="umpi-drawer-list-container">
                        {this.state.drawerTab === 0 && (
                            <Box sx={{ p: 3 }}>
                                {this.state.cabinets.map((item, index) => (
                                    <ListItem
                                        dense
                                        disablePadding
                                        key={index}>
                                        <ListItemButton onClick={() => this.handleClickOpenCabinet(item.uuid)}>
                                            <ListItemAvatar>
                                                <Avatar>
                                                    <RouterIcon />
                                                </Avatar>
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={item.name}
                                                secondary={item.address ? item.address : null}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </Box>
                        )}
                        {this.state.drawerTab === 1 && (
                            <Box sx={{ p: 3 }}>
                                {this.state.lightPoints.map((item, index) => (
                                    <ListItem
                                        dense
                                        disablePadding
                                        key={index}>
                                        <ListItemButton onClick={() => this.handleClickOpenLightPoint(item.uuid)}>
                                            <ListItemAvatar>
                                                <Avatar>
                                                    <EmojiObjectsIcon />
                                                </Avatar>
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={item.name}
                                                secondary={item.address ? item.address : null}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </Box>
                        )}
                    </div>
                </Drawer>

                <AddLightPointForm
                    cabinets={this.state.cabinets}
                    lightPoints={this.state.lightPoints}
                    gateways={this.state.gateways}
                    lampsArchive={this.state.lampsArchive}
                    luminaresArchive={this.state.luminaresArchive}
                    driversArchive={this.state.driversArchive}
                    supportsArchive={this.state.supportsArchive}
                    handleDialog={this.handleDialogLightPoint}
                    handleAddLightPoint={this.handleAddLightPoint}
                    handlePutLightpoint={this.handlePutLightpoint}
                    handleDelLightpoint={this.handleDelLightpoint}
                />

                <AddCabinetForm
                    handleDialog={this.handleDialogCabinet}
                    handleAddCabinet={this.handleAddCabinet}
                    handlePutCabinet={this.handlePutCabinet}
                    handleDelCabinet={this.handleDelCabinet}
                />

                <CSVUploadForm
                    projectId={this.state.projectIdSelected}
                    handleDialog={this.handleDialogUpload}
                    onUploadSuccess={this.handleCSVUploadSuccess} //Funzione di callback che riporta i nuovi LP al Map
                />

                <UserProfileForm
                    handleDialog={this.handleDialogProfile}
                />
            </Container>
        );
    }
}

export default withTranslation()(MainLayout);
